import youTubeSrc from '@arelia-assets/youtube-connection.svg';
import facebookSrc from '@arelia-assets/facebook-connection.svg';
import instagramSrc from '@arelia-assets/instagram-connection.svg';
import spotifySrc from '@arelia-assets/spotify.png';
import distrokidSrc from '@arelia-assets/distrokid.png';
import areliaSrc from '@arelia-assets/arelia.png';
import songtrustSrc from '@arelia-assets/song-trust-connection.svg';
import amazonSrc from '@arelia-assets/amazon.png';
import shopifySrc from '@arelia-assets/shopify.png';
import squreupSrc from '@arelia-assets/squre.webp';
import tiktokSrc from '@arelia-assets/tiktok.svg';
import appleMusicSrc from '@arelia-assets/apple-music.png';
import pandoraSrc from '@arelia-assets/pandora.png';
import cdbabySrc from '@arelia-assets/cdbaby.svg';
import twitterSrc from '@arelia-assets/twitter.png';
import ascapSrc from '@arelia-assets/ic_ascap.png';
import { ConnectionName } from '@arelia-types/connection';

export default function getAccountConnectionIcon(name: ConnectionName) {
  switch (name) {
    case ConnectionName.youtube:
      return youTubeSrc;
    case ConnectionName.facebook:
      return facebookSrc;
    case ConnectionName.instagram:
      return instagramSrc;
    case ConnectionName.spotify:
      return spotifySrc;
    case ConnectionName.distrokid:
      return distrokidSrc;
    case ConnectionName.arelia:
      return areliaSrc;
    case ConnectionName.songtrust:
      return songtrustSrc;
    case ConnectionName.amazon:
      return amazonSrc;
    case ConnectionName.shopify:
      return shopifySrc;
    case ConnectionName.square:
      return squreupSrc;
    case ConnectionName.tiktok:
      return tiktokSrc;
    case ConnectionName.appleMusic:
      return appleMusicSrc;
    case ConnectionName.pandora:
      return pandoraSrc;
    case ConnectionName.cdBaby:
      return cdbabySrc;
    case ConnectionName.twitter:
      return twitterSrc;
    case ConnectionName.ascap:
      return ascapSrc;
    default:
      return '';
  }
}
